import { v4 as uuidv4 } from 'uuid';
import { MESSAGE_TYPES, NOTIFICATION_TYPES } from './constants';
import { commsHandler } from './handlers';
export default class HelpScout {
    async getApplicationContext() {
        commsHandler.send(MESSAGE_TYPES.GET_APP_CONTEXT);
        return (await commsHandler.receive(MESSAGE_TYPES.SEND_APP_CONTEXT));
    }
    watchApplicationContext(callback) {
        commsHandler.listen(MESSAGE_TYPES.SEND_APP_CONTEXT, (data) => {
            callback(data);
        });
    }
    setClipboardText(text, successMessage = 'Text copied') {
        commsHandler.send(MESSAGE_TYPES.SET_CLIPBOARD_TEXT, {
            value: { text: text, successMessage: successMessage },
        });
    }
    setAppHeight(height) {
        commsHandler.send(MESSAGE_TYPES.SET_APP_HEIGHT, { value: height });
    }
    showNotification(type, text, options = {}) {
        if (type === NOTIFICATION_TYPES.CONFIRM) {
            options = options;
            if (!options.id) {
                // generate a unique id if one is not provided
                options.id = uuidv4();
            }
        }
        commsHandler.send(MESSAGE_TYPES.SHOW_NOTIFICATION, {
            value: {
                type,
                message: text,
                options: type === NOTIFICATION_TYPES.CONFIRM
                    ? options
                    : options,
            },
        });
        if (type === NOTIFICATION_TYPES.CONFIRM) {
            const confirmNotificationOptions = options;
            if (confirmNotificationOptions.onConfirm) {
                commsHandler.listen(MESSAGE_TYPES.CONFIRM_NOTIFICATION_CONFIRMED, (value) => {
                    const message = value;
                    if (message.id === confirmNotificationOptions.id &&
                        confirmNotificationOptions.onConfirm) {
                        confirmNotificationOptions.onConfirm();
                    }
                });
            }
            if (confirmNotificationOptions.onClose) {
                commsHandler.listen(MESSAGE_TYPES.CONFIRM_NOTIFICATION_CLOSED, (value) => {
                    const message = value;
                    if (message.id === confirmNotificationOptions.id &&
                        confirmNotificationOptions.onClose) {
                        confirmNotificationOptions.onClose();
                    }
                });
            }
        }
    }
    async getAppStyles() {
        commsHandler.send(MESSAGE_TYPES.GET_APP_STYLES);
        const { styles } = await commsHandler.receive(MESSAGE_TYPES.SEND_APP_STYLES);
        return styles;
    }
    openSidePanel(contentUrl) {
        commsHandler.send(MESSAGE_TYPES.OPEN_SIDE_PANEL, { value: contentUrl });
    }
    getInstallationIds() {
        const name = window?.name;
        return name && name.startsWith('app-')
            ? name
                .replace('app-', '')
                .split('-')
                .filter(item => !!item)
            : [];
    }
}
//# sourceMappingURL=HelpScout.js.map